import React, { Component, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import AddDecision from "../agendaDetails/AddDecision.issueList";
import { get, isFunction } from "lodash";
export default class AddDecisionConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddDecisionModal: false,
      showAddDecisionConfirmationModal: this.props
        .showAddDecisionConfirmationModal
    };
  }

  showAddDecisionModal = () => {
    const {
      issueDetails,
      defaultOpen,
      callApiOnSuccess,
      filterArray,
      meetingListData,
      agendasAssociatedWithIssue,
      handleClose
    } = this.props;
    const { showAddDecisionModal } = this.state;
    return (
      <>
        <AddDecision
          show={showAddDecisionModal}
          meetingListData={get(meetingListData, "data")}
          handleClose={() => {
            this.setState({
              showAddDecisionModal: false
            });
            handleClose();
          }}
          issues={issueDetails}
          project={
            get(issueDetails, "project") || get(issueDetails, "projectIssueDTO")
          }
          callApiOnSuccess={callApiOnSuccess}
          defaultOpen={defaultOpen}
          issueListStatus={true}
          filterArray={filterArray}
          showSaveAsDraft={false}
          callFromIssueAction={true}
          agendasAssociatedWithIssue={agendasAssociatedWithIssue}
        />
      </>
    );
  };

  render() {
    const {
      handleClose,
      agendasAssociatedWithIssue,
      showAddDecisionConfirmationModal
    } = this.props;
    return (
      <>
        {this.state.showAddDecisionModal === true &&
          this.showAddDecisionModal()}
        <Modal
          show={showAddDecisionConfirmationModal}
          onHide={handleClose}
          id="add-decision-modal"
          className="confirmation-modal"
        >
          <div class="confirm-icon" />
          <Modal.Header closeButton />
          <Modal.Body>
            <h4 class="page-heading">Add Decision</h4>
            <p>
              The issue is already associated with following open Agenda(s):{" "}
              {(agendasAssociatedWithIssue || []).map((agenda, index) => (
                <span key={`list-key-${index}`}>
                  <a href={"/agenda-details?agendaId=" + agenda.id}>
                    #{agenda.id}-{agenda.meetingName}
                    {index <= agendasAssociatedWithIssue.length - 2 ? "," : " "}
                    &nbsp;
                  </a>
                </span>
              )) || "NA"}
            </p>
            <p>Do you still want to add a decision?</p>
          </Modal.Body>
          <div className="add-desicion-btn edit-project-iig-buttons justify-content-end d-flex">
            <div>
              <Button
                className="no-button btn-light no-padding"
                onClick={handleClose}
              >
                No
              </Button>
            </div>
            <div>
              <Button
                className="continue-adding-btn btn-orange no-padding"
                onClick={() =>
                  this.setState({
                    showAddDecisionModal: true,
                    showAddDecisionConfirmationModal: false
                  })
                }
              >
                Continue Adding
              </Button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
